import defaultStyled, { ThemedStyledInterface, createGlobalStyle } from "styled-components";
import theme from "./theme";
import { ThemedColorProps } from "./types";

const styled = (defaultStyled as any) as ThemedStyledInterface<typeof theme>;

export { styled, theme, ThemedColorProps, createGlobalStyle };
export * from "styled-components";


// WEBPACK FOOTER //
// ./src/styles/index.ts